import React from 'react';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import AuditsTable from './components/AuditsTable';
import StartAuditModal from './components/StartAuditModal';

const Audits: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <>
      <Record
        Header={
          <MainHeader
            title="Audits"
            breadcrumbs={[
              { label: 'Audits', link: routes.dashboard.audits.forms.toString() },
              { label: 'Overview', link: routes.dashboard.audits.forms.toString() },
            ]}
            action={
              <Button variant="contained" size="large" onClick={() => setOpenModal(true)}>
                New audit
              </Button>
            }
          />
        }
        Content={(onError) => <AuditsTable onError={onError} />}
        navBarHeight={navBarHeight}
      />
      <StartAuditModal open={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};

export default Audits;
